// Testimonials — REAL quotes only. Grows as new real quotes come in.
// Chris: append new entries here as friends/clients give you real testimonials.
// Every entry must be REAL. No fabrication.

export const TESTIMONIALS = [
  {
    quote: "Kit has always been genuine, and he's really great at getting his message through to me. I've used him 4 times now.",
    name: "Repeat client",
    role: "Small business owner",
    city: "DFW",
    verified: true,
  },
  {
    quote: "Kit is the coolest down-to-earth genius when it comes to Google. I've built 2 websites with him — he's always in jeans and a t-shirt.",
    name: "Repeat client",
    role: "Business owner · 2 sites built",
    city: "DFW",
    verified: true,
  },
];

// Kit's founder case-study — the story he wants to tell in his own voice.
export const PAM_CASE_STUDY = {
  client: "Pam",
  role: "Accident attorney",
  city: "Irving, TX",
  timeline: "3 months",
  before: "8–12 new clients / month",
  after: "50+ new clients / month",
  revenueMultiplier: "4×",
  quote:
    "Pam and I finally got her SEO right after 3 months. She's an accident attorney in Irving. She went from 8-12 new customers a month to over 50 every month — and she's billing 4× the money she used to.",
};
